package com.banyan.flightviewer.web.state

import com.banyan.flightviewer.manager.SettingsManager
import com.banyan.flightviewer.platform.SettingsStore
import com.banyan.flightviewer.state.AppState
import com.banyan.flightviewer.web.api.ServerClient
import com.banyan.flightviewer.web.platform.WebAlertManager
import com.banyan.flightviewer.web.platform.WebAudioPlayer

/**
 * Holds the shared app state, manager singletons, and the server client used
 * by every web component. One instance per page load.
 */
class WebAppContainer {
    val appState: AppState = AppState()
    val settingsStore: SettingsStore = SettingsStore()
    val settingsManager: SettingsManager = SettingsManager(appState, settingsStore)
    val serverClient: ServerClient = ServerClient()
    val alertManager: WebAlertManager = WebAlertManager()
    // uiState has to be constructed before `monitoring` because the
    // monitoring loop reads `uiState.mapQueryArea` to pick query coords.
    val uiState: WebUiState = WebUiState(appState, settingsStore)
    val monitoring: WebMonitoringLoop = WebMonitoringLoop(appState, serverClient, uiState, alertManager)
    val audioPlayer: WebAudioPlayer = WebAudioPlayer(appState)
}
